import { render, staticRenderFns } from "./TermsAndConditionsPage.vue?vue&type=template&id=a8531a94&scoped=true"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=a8531a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8531a94",
  null
  
)

export default component.exports